"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = exports.TransactionType = exports.PaymentState = exports.Currency = exports.Channel = exports.DiscountType = exports.PaymentProcessor = exports.VATType = exports.LineAddonType = exports.LineType = exports.OrderType = exports.OrderSessionState = void 0;
var OrderSessionState;
(function (OrderSessionState) {
    OrderSessionState[OrderSessionState["PENDING"] = 1] = "PENDING";
    OrderSessionState[OrderSessionState["COMPLETED"] = 4] = "COMPLETED";
    OrderSessionState[OrderSessionState["ABANDONED"] = 7] = "ABANDONED";
})(OrderSessionState || (exports.OrderSessionState = OrderSessionState = {}));
var OrderType;
(function (OrderType) {
    OrderType["NEW_SALE"] = "NEW_SALE";
    OrderType["FULL_CANCELLATION"] = "FULL_CANCELLATION";
    OrderType["PARTIAL_CANCELLATION"] = "PARTIAL_CANCELLATION";
})(OrderType || (exports.OrderType = OrderType = {}));
// Describes the type of line in an order session.
var LineType;
(function (LineType) {
    // regular sale line
    LineType[LineType["SaleLine"] = 1] = "SaleLine";
    // Cancelation line. If we cancel a line, we create a new line with type CancelLine.
    LineType[LineType["CancelLine"] = 2] = "CancelLine";
})(LineType || (exports.LineType = LineType = {}));
// Descirbes the type of addone line in an order session.
var LineAddonType;
(function (LineAddonType) {
    LineAddonType[LineAddonType["REGULAR"] = 1] = "REGULAR";
    LineAddonType[LineAddonType["AUTO_INCLUDED"] = 2] = "AUTO_INCLUDED";
})(LineAddonType || (exports.LineAddonType = LineAddonType = {}));
// Indicates the type of VAT applied to the ticket price
// Included: VAT is included in the ticket price
// Excluded: VAT is not included in the ticket price
var VATType;
(function (VATType) {
    VATType[VATType["INCLUDED"] = 1] = "INCLUDED";
    VATType[VATType["EXCLUDED"] = 2] = "EXCLUDED";
})(VATType || (exports.VATType = VATType = {}));
var PaymentProcessor;
(function (PaymentProcessor) {
    PaymentProcessor["WALLEE"] = "PROCESSOR_WALLEE";
    PaymentProcessor["ADYEN"] = "PROCESSOR_ADYEN";
    PaymentProcessor["ORGANISER"] = "PROCESSOR_ORGANISER";
})(PaymentProcessor || (exports.PaymentProcessor = PaymentProcessor = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType[DiscountType["NORMAL"] = 1] = "NORMAL";
    DiscountType[DiscountType["PERCENT"] = 2] = "PERCENT";
    DiscountType[DiscountType["FLAT"] = 3] = "FLAT";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
var Channel;
(function (Channel) {
    Channel["WIDGET"] = "widget";
    Channel["SMEETZ_POS"] = "Smeetz POS";
    Channel["DISCOVER_SMEETZ"] = "discover_smeetz";
    Channel["CREATE_A_SALES"] = "create_a_sales";
    Channel["KIOSK"] = "kiosk";
    Channel["STANDALONE"] = "Standalone";
    Channel["BOOKING_VIEW"] = "booking_view";
    Channel["OLD_POS"] = "old_POS";
    Channel["POS"] = "POS";
    Channel["OTA"] = "OTA";
    Channel["IMPORT_BOOKING"] = "import_booking";
    Channel["BO"] = "BO";
    Channel["IMPORT_ORDER"] = "Import_Order";
    Channel["BACK_OFFICE"] = "Back office";
    Channel["CHATBOT"] = "chatbot";
    Channel["CREATE_A_SALE"] = "create a sale";
})(Channel || (exports.Channel = Channel = {}));
var Currency;
(function (Currency) {
    Currency["CHF"] = "CHF";
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["GBP"] = "GBP";
    Currency["AED"] = "AED";
    Currency["CAD"] = "CAD";
    Currency["NZD"] = "NZD";
})(Currency || (exports.Currency = Currency = {}));
var PaymentState;
(function (PaymentState) {
    PaymentState[PaymentState["PENDING"] = 1] = "PENDING";
    PaymentState[PaymentState["STARTED"] = 2] = "STARTED";
    PaymentState[PaymentState["AUTHORIZED"] = 3] = "AUTHORIZED";
    PaymentState[PaymentState["TOKENIZED"] = 4] = "TOKENIZED";
    PaymentState[PaymentState["COMPLETED"] = 5] = "COMPLETED";
    PaymentState[PaymentState["FAILED"] = 6] = "FAILED";
    PaymentState[PaymentState["CANCELLED"] = 7] = "CANCELLED";
})(PaymentState || (exports.PaymentState = PaymentState = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["PAYMENT"] = 1] = "PAYMENT";
    TransactionType[TransactionType["DISCOUNT"] = 2] = "DISCOUNT";
    TransactionType[TransactionType["REFUND"] = 3] = "REFUND";
    TransactionType[TransactionType["TICKET"] = 4] = "TICKET";
    TransactionType[TransactionType["PAYMENT_FEE_USER"] = 5] = "PAYMENT_FEE_USER";
    TransactionType[TransactionType["TAX"] = 6] = "TAX";
    TransactionType[TransactionType["CASH_TRANSFER"] = 7] = "CASH_TRANSFER";
    TransactionType[TransactionType["CASH_CORRECTION_GAIN"] = 8] = "CASH_CORRECTION_GAIN";
    TransactionType[TransactionType["CASH_CORRECTION_LOSS"] = 9] = "CASH_CORRECTION_LOSS";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    // Unknown/Pending
    PaymentMethod["UNKNOWN"] = "UNKNOWN";
    PaymentMethod["PENDING"] = "PENDING";
    // Discount Types
    PaymentMethod["PROMO_CODE"] = "PROMO_CODE";
    PaymentMethod["VOUCHER"] = "VOUCHER";
    PaymentMethod["GIFT_CARD"] = "GIFT_CARD";
    PaymentMethod["MEMBERSHIP"] = "MEMBERSHIP";
    PaymentMethod["DISCOUNT"] = "DISCOUNT";
    PaymentMethod["MEMBERSHIP_DISCOUNT"] = "MEMBERSHIP_DISCOUNT";
    PaymentMethod["EXPERIENCEBANK"] = "EXPERIENCEBANK";
    PaymentMethod["INVITATION"] = "invitation";
    PaymentMethod["REFUNDED_VOUCHER"] = "REFUNDED_VOUCHER";
    // Credit Cards & Digital Payments
    PaymentMethod["VISA"] = "VISA";
    PaymentMethod["GOOGLEPAY"] = "GOOGLEPAY";
    PaymentMethod["MASTERCARD"] = "MASTERCARD";
    PaymentMethod["AMEX"] = "AMEX";
    PaymentMethod["APPLEPAY"] = "APPLEPAY";
    PaymentMethod["APPLEPAY_VISA"] = "APPLEPAY_VISA";
    PaymentMethod["APPLEPAY_MASTERCARD"] = "APPLEPAY_MASTERCARD";
    PaymentMethod["APPLEPAY_MAESTRO"] = "APPLEPAY_MAESTRO";
    PaymentMethod["APPLEPAY_AMEX"] = "APPLEPAY_AMEX";
    PaymentMethod["TWINT"] = "TWINT";
    PaymentMethod["POST_CARD"] = "POSTCARD";
    PaymentMethod["PAYPAL"] = "PAYPAL";
    PaymentMethod["POSTFINANCE_EFINANCE"] = "POSTEFINANCE";
    PaymentMethod["MAESTRO"] = "MAESTRO";
    PaymentMethod["CHINA_UNION_PAY"] = "CHINA_UNION_PAY";
    PaymentMethod["IDEAL"] = "IDEAL";
    PaymentMethod["BANCONTACT"] = "BANCONTACT";
    PaymentMethod["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    PaymentMethod["ALIPAY"] = "ALIPAY";
    PaymentMethod["WECHATPAY_WEB"] = "WECHATPAY_WEB";
    PaymentMethod["DINERS"] = "DINERS";
    PaymentMethod["JCB"] = "JCB";
    // Traditional Payment Methods
    PaymentMethod["INVOICE"] = "INVOICE";
    PaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethod["FREE"] = "FREE";
    PaymentMethod["EXTERNAL_VOUCHER"] = "EXTERNAL_VOUCHER";
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["CHEQUE"] = "CHEQUE";
    PaymentMethod["CHEQUE_CULTURE"] = "CHEQUE_CULTURE";
    PaymentMethod["CHEQUE_VACANCES"] = "CHEQUE_VACANCES";
    PaymentMethod["PASS_CULTURE"] = "PASS_CULTURE";
    PaymentMethod["COUPON_SPORT"] = "COUPON_SPORT";
    PaymentMethod["BON_DE_COMMANDE"] = "BON_DE_COMMANDE";
    PaymentMethod["BON_DE_COMMANDE_RECEPTIONNE"] = "BON_DE_COMMANDE_RECEPTIONNE";
    PaymentMethod["CHORUS"] = "CHORUS";
    PaymentMethod["TO_BE_INVOICED"] = "TO_BE_INVOICED";
    // POS Related
    PaymentMethod["POS_ADYEN"] = "POS_ADYEN";
    PaymentMethod["STAND_ALONE_ADYEN"] = "STAND_ALONE_ADYEN";
    PaymentMethod["POS_ADYEN_CREATE_ORDER"] = "POS_ADYEN_CREATE_ORDER";
    PaymentMethod["POS_ADYEN_PAY_BY_LINK"] = "POS_ADYEN_PAY_BY_LINK";
    PaymentMethod["KIOSK_ADYEN"] = "KIOSK_ADYEN";
    PaymentMethod["POS_CARD"] = "POS_CARD";
    PaymentMethod["POS_CASH"] = "POS_CASH";
    PaymentMethod["POS_TWINT"] = "POS_TWINT";
    PaymentMethod["POS_INVOICE"] = "POS_INVOICE";
    PaymentMethod["POS_BANK_TRANSFER"] = "POS_BANK_TRANSFER";
    PaymentMethod["POS_INVITATION"] = "POS_INVITATION";
    PaymentMethod["POS_EXTERNAL"] = "POS_EXTERNAL";
    PaymentMethod["POS_PROMO_CODE"] = "POS_PROMO_CODE";
    PaymentMethod["POS_DISCOUNT"] = "POS_DISCOUNT";
    PaymentMethod["POS_VOUCHER"] = "POS_VOUCHER";
    PaymentMethod["POS_GIFT_CARD"] = "POS_GIFT_CARD";
    PaymentMethod["POS_MEMBERSHIP"] = "POS_MEMBERSHIP";
    // Other Methods
    PaymentMethod["SPONSORED"] = "SPONSORED";
    PaymentMethod["POWERPAY_INVOICE"] = "POWERPAY_INVOICE";
    PaymentMethod["TICKET_ONLINE"] = "TICKET_ONLINE";
    PaymentMethod["TICKET_POS"] = "TICKET_POS";
    PaymentMethod["PAYMENT_FEE_ONLINE"] = "PAYMENT_FEE_ONLINE";
    PaymentMethod["TAX"] = "TAX";
    PaymentMethod["OCCYG"] = "OCCYG";
    PaymentMethod["CE"] = "CE";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
//# sourceMappingURL=enums.js.map